// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"dbe911a0","453":"825386d9","682":"dee51a41"}[chunkId] + ".chunk.js";
};